import { createContext } from 'react'

/**
 * @name RadioGroupContext
 */
export default createContext(null)
